import PropTypes from 'prop-types'
import {
  StyledContainer,
  StyledTopContainer,
  StyledHeader,
  StyledTitle,
  StyledIndicator,
  StyledCurrentValue,
  StyledProgressBarContainer,
  StyledCreditIcon,
  ProgressBarOverrides,
  StyledAccordionContainer,
  StyledPanelTitleContainer,
  StyledPanelLeft,
  StyledPanelTitleText,
  StyledPanelCredit,
  StyledPanelContentContainer,
  ButtonOverrides,
  PanelOverrides,
} from './styled-components'
import { ProgressBar } from 'baseui/progress-bar'
import { Accordion, Panel } from 'baseui/accordion'
import CreditIcon from './selectra_check.svg'
import useCreditBooster from './useCreditBooster'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'

const CreditBoosterContent = ({ t, scriptArray, currentValue, maxCredit, reachedMax, scrollToAdditionalSaleTab }) => {
  const { getIcon } = useCreditBooster()

  return (
    <StyledContainer>
      <StyledTopContainer>
        <StyledHeader>
          <StyledTitle>{t('subscriptionForm:credit_booster.title')}</StyledTitle>
          <StyledIndicator>
            <StyledCurrentValue $reachedMax={reachedMax}>{currentValue}</StyledCurrentValue>/{maxCredit}
          </StyledIndicator>
        </StyledHeader>
        <StyledProgressBarContainer>
          <ProgressBar value={currentValue} maxValue={maxCredit} overrides={ProgressBarOverrides} />
          <StyledCreditIcon src={CreditIcon} alt='Credit Icon' />
        </StyledProgressBarContainer>
      </StyledTopContainer>
      <StyledAccordionContainer>
        <Accordion>
          {scriptArray.map((sale, index) => {
            const isLast = index === scriptArray.length - 1
            return (
              <Panel
                key={sale.name}
                overrides={PanelOverrides(isLast)}
                title={
                  <StyledPanelTitleContainer>
                    <StyledPanelLeft>
                      {getIcon(sale.icon)}
                      <StyledPanelTitleText>{sale.title}</StyledPanelTitleText>
                    </StyledPanelLeft>
                    <StyledPanelCredit $sold={sale.sold}>
                      {sale.sold ? `+${sale.credits}` : sale.credits}
                    </StyledPanelCredit>
                  </StyledPanelTitleContainer>
                }
              >
                <StyledPanelContentContainer>
                  <p>{sale.description}</p>
                  {!sale.sold && (
                    <SDButton overrides={ButtonOverrides} onClick={() => scrollToAdditionalSaleTab(sale.name)}>
                      {t('subscriptionForm:credit_booster.add_button')}
                    </SDButton>
                  )}
                </StyledPanelContentContainer>
              </Panel>
            )
          })}
        </Accordion>
      </StyledAccordionContainer>
    </StyledContainer>
  )
}

CreditBoosterContent.propTypes = {
  t: PropTypes.func,
  scriptArray: PropTypes.arrayOf(PropTypes.object),
  currentValue: PropTypes.number,
  maxCredit: PropTypes.number,
  reachedMax: PropTypes.bool,
  scrollToAdditionalSaleTab: PropTypes.func,
}

export default CreditBoosterContent
